import { LitElement, css, html } from "lit";
import { customElement, state } from "lit/decorators.js";

@customElement("c-manual-flag-to-solved")
export class ManualFlagToSolvedWidgetWidget extends LitElement {
    static styles = css`
        :host {
            display: block;
            height: 100%;
            text-align: center;
            container: widget / size;
        }

        @container (height < 100px) {
            div {
                font-size: 0.6em;
            }
        }

        @container (height >= 100px) and (height < 150px) {
            div {
                font-size: 0.8em;
            }
        }

        @container (height >= 150px) and (height < 200px) {
            div {
                font-size: 1em;
            }
        }

        @container (height >= 200px) and (height < 250px) {
            div {
                font-size: 1.5em;
            }
        }

        @container (height >= 250px) {
            div {
                font-size: 2em;
            }
        }
    `;

    @state()
    averageDaysToSolve: number = 0;

    @state()
    qasWithManualFlag: number = 0;

    async connectedCallback() {
        super.connectedCallback();

        this.averageDaysToSolve = 3;
        this.qasWithManualFlag = 477;
    }

    render() {
        return html`<div>
            <h2>From 'manual flag' to solved</h2>
            <p>
                Average time to solve: ${this.averageDaysToSolve} days
                <br />QA's with manual flag ${this.qasWithManualFlag}
            </p>
        </div>`;
    }
}
